import React, { useEffect, useState } from 'react';
import qs from 'query-string';

import { CommonProps } from '../../components/helpers/props';

import { Navigate, useNavigate } from 'react-router-dom';
import currentUrlUtils from 'src/shared/utils/currentUrlUtils';
import { appendLogoutCallbackEntity } from 'src/shared/utils/sessionStorageManager';

import { AuthEntity, SignInWithTempTokenReqEntity } from 'src/store/auth/auth';
import useAuthStore from 'src/hooks/auth/useAuthStore';
import config from 'src/shared/config';
import { useAlert } from 'fasoo-ui-component-next';

export interface LoginWithTempTokenProps extends CommonProps {
  contextPath: string;
  redirectsignIn: string;
  isAuthenticated: boolean;
  authEntity: AuthEntity | undefined;
  signInWithTempToken: (reqEntity: SignInWithTempTokenReqEntity) => Promise<AuthEntity>;
  redirectToProduct: () => void;
  redirectToProductUrls: string[];
}

const LoginWithTempToken: React.FC<LoginWithTempTokenProps> = ({
  contextPath,
  redirectsignIn,
  isAuthenticated,
  authEntity,
  signInWithTempToken,
  redirectToProduct,
  redirectToProductUrls,
}) => {
  const navigate = useNavigate();
  const { alert } = useAlert();
  const [runTempTokenSignIn, setRunTempTokenSignIn] = useState<boolean>(false);

  const {
    bearer: token,
    jwt: jwtToken,
    redirectUrl: paramRedirectUrl,
    logoutUrl,
  } = currentUrlUtils.getAllFirstQuery();
  const redirectUrl = paramRedirectUrl || `${contextPath}`; //config.url('/');

  useEffect(() => {
    if (isAuthenticated && authEntity) {
      // redirect 대상이 내부 페이지면 react-router 사용, 아니면 기본 redirect 사용.
      // fast일 경우에는 몇 가지 처리가 더 필요함
      if (redirectUrl.startsWith(contextPath)) {
        navigate(redirectUrl);
      } else if (redirectUrl.startsWith('http')) {
        const findUrl = redirectToProductUrls.find((url) => redirectUrl.includes(url));
        if (findUrl) {
          // TODO FAST인지를 판단하는 방법 좀 더 nice하게는...
          // FAST는 로그아웃 url 등록하고, 임시 토큰 받아서 redirect
          redirectToProduct();
        }
      } else {
        currentUrlUtils.setHref(redirectUrl);
      }
    } else if (!isAuthenticated && (token || jwtToken)) {
      // FXM바로가기에서 FXM User에 진입할 때, 임시토큰으로 로그인을 시도한다.
      if (!runTempTokenSignIn) {
        setRunTempTokenSignIn(true);
        signInWithTempToken({
          redirectUrl,
          token: jwtToken ? jwtToken : token ? token : '',
        })
          .then(() => {
            // do nothing
          })
          .catch((err) => {
            navigate(config.url('/'));
            // alert(err, 'warning');
          });
      }
    }
  }, [
    alert,
    navigate,
    isAuthenticated,
    logoutUrl,
    redirectUrl,
    signInWithTempToken,
    token,
    jwtToken,
    redirectToProduct,
    redirectToProductUrls,
    authEntity,
    contextPath,
    runTempTokenSignIn,
  ]);

  if (!isAuthenticated && !(token || jwtToken)) {
    return (
      <Navigate
        to={qs.stringifyUrl({
          url: redirectsignIn, //config.url('/sign-in'),
          query: {
            redirectUrl,
            logoutUrl,
          },
        })}
      />
    );
  }

  return null;
};

const LoginWithTempTokenOutside: React.FC = () => {
  const { isAuthenticated, authEntity, signInWithTempToken } = useAuthStore();

  const {
    bearer: token,
    jwt: jwtToken,
    redirectUrl: paramRedirectUrl,
    logoutUrl,
  } = currentUrlUtils.getAllFirstQuery();
  const redirectUrl = paramRedirectUrl || config.url('/');

  const redirectProduct = (): void => {
    if (logoutUrl && token && jwtToken) {
      appendLogoutCallbackEntity({
        logoutUrl,
        token,
        jwt: jwtToken,
      });
    }
    // append bearer
    const parsedRedirectUrl = qs.parseUrl(redirectUrl);
    currentUrlUtils.setHref(
      qs.stringifyUrl({
        url: parsedRedirectUrl.url,
        query: {
          ...parsedRedirectUrl.query,
          bearer: jwtToken ? jwtToken : token ? token : '', // FED와 연동할때 재 고려 필요
        },
      })
    );
  };

  return (
    <LoginWithTempToken
      contextPath={config.contextPath}
      redirectsignIn={config.url('/sign-in')}
      isAuthenticated={isAuthenticated}
      authEntity={authEntity}
      signInWithTempToken={signInWithTempToken}
      redirectToProduct={redirectProduct}
      redirectToProductUrls={['/fast']}
    />
  );
};

export default LoginWithTempTokenOutside;
